import { PudoTransactionVolumeLineChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast30DaysPudoTransactionVolumeLineChart } from './use-last-30-days-pudo-transaction-volume-line-chart';

export interface Last30DaysPudoTransactionVolumeLineChartProps {
    accountId: string;
    navigateUrl?: string;
}

export const Last30DaysPudoTransactionVolumeLineChart = (props: Last30DaysPudoTransactionVolumeLineChartProps) => {
    const { data, isLoading, subtitle, navigateUrl } = useLast30DaysPudoTransactionVolumeLineChart(props);

    return (
        <StatisticsCard
            chartKey={PudoTransactionVolumeLineChart.definition.key}
            navigateUrl={navigateUrl}
            title={
                <FormattedMessage
                    id='platform.statistics.pudo.last-30-days-pudo-transaction-volume-line-chart.title'
                    description='Title of the PuDo dashboard chart showing completed transaction volume over the last 30 days'
                    defaultMessage='Completed transaction volume'
                />
            }
            subtitle={subtitle}
            isLoading={isLoading}
            hasData={!!data}>
            {data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <PudoTransactionVolumeLineChart
                        data={data}
                        minHeight={80}
                        showLabels='minimal'
                        tooltipShared
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
